import { createLocale } from "./createLocale";

export const cs = createLocale({
  header: {
    title: "Jděte globálně. 2 $ za Short. Jakýkoli jazyk!",
    subtitle: "🔥Plaťte jen za výsledek – od $0.089 do $0.009 za sekundu🔥",
  },
  steps: {
    uploadVideo: "Nahrát video",
    selectLanguages: "Vybrat jazyky",
    conversionResult: "Převod a výsledek",
  },
  upload: {
    dragAndDrop: "Přetáhněte sem svůj video soubor",
    orClickToSelect: "nebo klikněte pro výběr",
    supportedFormats: "Podporované formáty: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximální velikost souboru: 200 MB",
    maxDuration: "• Maximální délka: 30 s",
    chooseFile: "Vybrat soubor",
    selectedFile: "Vybraný soubor:",
    size: "Velikost:",
    fileTypeError: "Vyberte prosím video soubor",
    fileSizeError: "Velikost souboru ({size} MB) překračuje maximální limit 200 MB",
    durationError: "Délka videa ({duration} s) překračuje maximální limit 30 s",
    fileReadError: "Video soubor se nepodařilo načíst. Zkuste prosím jiný soubor.",
  },
  languages: {
    sourceAudioLanguage: "Jazyk zdrojového audia",
    targetAudioLanguage: "Jazyk cílového audia",
    selectLanguage: "Vyberte jazyk...",
  },
  conversion: {
    replaceAudio: "Klonovat můj hlas",
    uploadVideoAndSelectLanguages: "Nahrajte video a vyberte jazyky pro pokračování",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Zásady ochrany osobních údajů",
    termsOfUse: "Podmínky použití",
  },
  languageOptions: {
    cs: "Čeština",
  },
});
